export default __webpack_public_path__ + "static/media/city-hall-forum.e5a88a55.svg";